import { Component } from '@angular/core';
import { CommonService } from '../../../../../shared/common.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  year: any;
  Year:any= new Date().getFullYear();
  constructor(public common: CommonService) {
    debugger
    this.common.TaxYearLicence.subscribe((data: any) => {
      if (data) {
        this.year = this.common.TaxYear.split(' ')[2];
        //this.year = this.common.TaxYear
        this.year = this.year
      }
    })
  }
}
